import { useState } from 'react';

export const useApplicationAccountsSearch = () => {
    const [keyword, setKeyword] = useState('');

    const handleFilterByKeyword = (newKeyword: string) => {
        setKeyword(newKeyword);
    };

    return {
        keyword,
        handleFilterByKeyword,
    };
};
